enum PatientMergeEligibilityStatus {
    /// <summary>No status detected for either patients.</summary>
    None = 0,

    /// <summary>The Main patient has portal account.</summary>
    MergeToPatientHasPortal = 1,
    /// <summary>The Source patient has portal account.</summary>
    MergeFromPatientHasPortal = 1 << 1,
    /// <summary>The Main patient is readonly.</summary>
    MergeToPatientIsReadOnly = 1 << 2,
    /// <summary>The Source patient is readonly.</summary>
    MergeFromPatientIsReadOnly = 1 << 3,

    /// <summary>Both patients have a portal account.</summary>
    BothPatientsHavePortal = MergeToPatientHasPortal | MergeFromPatientHasPortal,
    /// <summary>Both patients are readonly</summary>
    BothPatientsAreReadonly = MergeToPatientIsReadOnly | MergeFromPatientIsReadOnly
}

export { PatientMergeEligibilityStatus };
